import {create} from 'zustand';
import {ChangeUnitStore} from './types';

const useChangeUnitDialogStore = create<ChangeUnitStore>(set => ({
	changeUnitDialog: false,
	setChangeUnitDialog: value => set({changeUnitDialog: value}),
}));

export {useChangeUnitDialogStore};
